// TelcoTrack - Body scroll lock helper
// Shared by any full-screen overlay (modal, mobile nav drawer) so background content can't
// scroll while the overlay is open. Reference-counted so nested/concurrent overlays (e.g. a
// modal opened while the mobile drawer is open) don't unlock the scroll prematurely.

let lockCount = 0;
let previousOverflow = '';
let previousPaddingRight = '';

/** Locks `document.body` scrolling. Safe to call multiple times; pair each call with `unlockBodyScroll`. */
export function lockBodyScroll(): void {
  if (lockCount === 0) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    previousOverflow = document.body.style.overflow;
    previousPaddingRight = document.body.style.paddingRight;
    document.body.style.overflow = 'hidden';
    // Compensate for scrollbar removal so layout doesn't shift horizontally.
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
  lockCount++;
}

/** Releases one lock acquired via `lockBodyScroll`. Restores original styles once the count reaches 0. */
export function unlockBodyScroll(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousPaddingRight;
  }
}
